import { render, staticRenderFns } from "./Acknowledgement.vue?vue&type=template&id=8f3281a6&"
import script from "./Acknowledgement.vue?vue&type=script&lang=js&"
export * from "./Acknowledgement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports